import pkcepair from 'pkce-pair';
import formurlencoded from 'form-urlencoded';
import formurldecoded from 'form-urldecoded';

import {
  storageSessSetItem,
  storageSessGetItem
} from './ssohandy-storage.mjs';

import {
  sessRefresh,
  sessResumeTry,
  sessSet,
  sessGet,
  sessClear
} from './ssohandy-sess.mjs';

import {
  reqUserinfoGET,
  reqOpenIdConfigGET,
  reqTokenGrantAuthCodePOST,
  reqRevokeTokenPOST
} from './ssohandy-req.mjs';

const ssohandyOpts = opts => {
  if ( !opts )
    throw new Error( '[!!!] sso-handy: invalid opts' );
  if ( typeof opts.client_id !== 'string' )
    throw new Error( '[!!!] sso-handy: invalid opts.client_id' );
  if ( typeof opts.redirect_uri !== 'string' )
    throw new Error( '[!!!] sso-handy: invalid opts.redirect_uri' );
  if ( typeof opts.openid_uri !== 'string' )
    throw new Error( '[!!!] sso-handy: invalid opts.openid_uri' );

  return opts;
};

const ssohandyTokenURIGet = async opts => (
  ( await reqOpenIdConfigGET( opts ) ).token_endpoint );

// const oauthUriAuthorization = async opts => (
const ssohandyAuthCodeURICreate = async opts => (
  ( await reqOpenIdConfigGET( opts ) ).authorization_endpoint + '?' + formurlencoded({
    state: opts.state,
    client_id: opts.client_id,
    redirect_uri: opts.redirect_uri,
    scope: 'openid profile email',
    response_type: 'code',
    response_mode: 'query',
    nonce: opts.nonce,
    oauth_client: opts.oauth_client,
    code_challenge: opts.code_challenge,
    code_challenge_method: 'S256'
  })
);

const ssohandyStateKeyGen = len => pkcepair
  .createVerifier( window.crypto, len || 40 );

const ssohandyLoginRedirect = async ( opts, state ) => {
  const { crypto } = window;
  const { openid_uri, redirect_uri, client_id } = ssohandyOpts( opts );
  const stateIsPrefixed = redirect_uri.startsWith( 'https://localhost' );
  const stateKey = ( stateIsPrefixed ? 'local' : '' ) + ssohandyStateKeyGen( 40 );
  const { verifier, challenge } = await pkcepair( crypto );
  
  storageSessSetItem( stateKey, JSON.stringify( state || {}) );
  storageSessSetItem( 'verifier', verifier );

  window.location.assign( await ssohandyAuthCodeURICreate({
    openid: opts.openid,
    openid_uri,
    client_id,
    redirect_uri,
    state: stateKey,
    code_challenge: challenge,
    oauth_client: btoa( JSON.stringify({
      name: 'ssohandy',
      version: '0.0.1'
    }) )
  }) );
};

const ssohandyLoginGrantIsPresent = () => {
  const query = formurldecoded( window.location.search );
  const state = storageSessGetItem( query.state );

  return Boolean( query.code && query.state && state );
};

const ssohandyLoginGrantSpend = async opts => {
  const query = formurldecoded( window.location.search );
  const state = storageSessGetItem( query.state );
  const verifier = storageSessGetItem( 'verifier' );

  if ( !state ) {
    throw new Error( '[!!!] sso-handy: grant details not present, missing state' );
  }

  const res = await reqTokenGrantAuthCodePOST( opts, query.code, verifier );
  if ( !/2\d\d/.test( res.status ) ) {
    throw new Error( res.json.error_description || res.statusText || 'grant request error' );
  }

  window.history.replaceState({}, document.title, window.location.pathname );

  return {
    refresh_token: res.json.refresh_token,
    access_token: res.json.access_token,
    token_type: res.json.token_type,
    expires_in: res.json.expires_in,
    id_token: res.json.id_token,
    scope: res.json.scope,
    state
  };
};

const ssohandyUserinfo = reqUserinfoGET;

const ssohandyLoginRevoke = reqRevokeTokenPOST;

const ssohandyPasetoDecodeNode = paseto => JSON.parse(
  Buffer.from( paseto.split( '.' )[2], 'base64' ).subarray( 0, -64 ) );

const ssohandyPasetoDecodeBrowser = paseto => {
  const base64 = paseto.split( '.' )[2].replace( /-/g, '+' ).replace( /_/g, '/' );

  return JSON.parse( decodeURIComponent( atob( base64 ).slice( 0, -64 )
    .split( '' )
    .map( c => '%' + ( '00' + c.charCodeAt( 0 ).toString( 16 ) ).slice( -2 ) )
    .join( '' ) ) );
};

const ssohandyPasetoDecode = typeof Buffer === 'function'
  ? ssohandyPasetoDecodeNode
  : ssohandyPasetoDecodeBrowser;

const ssohandyLoginRevokeAndClear = async oauthDetails => {
  await ssohandyLoginRevoke( oauthDetails );
  sessClear();
};

export {
  ssohandyTokenURIGet,
  ssohandyAuthCodeURICreate,
  ssohandyLoginRevoke,
  ssohandyLoginRedirect,
  ssohandyLoginGrantIsPresent,
  ssohandyLoginGrantSpend,
  ssohandyLoginRevokeAndClear,
  ssohandyUserinfo,
  ssohandyStateKeyGen,
  ssohandyPasetoDecode,
  ssohandyPasetoDecodeNode,
  ssohandyPasetoDecodeBrowser,

  sessRefresh as ssohandySessRefresh,
  sessResumeTry as ssohandySessResumeTry,
  sessClear as ssohandySessClear,
  sessSet as ssohandySessSet,
  sessGet as ssohandySessGet
};
